import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/blog/page.tsx");
